import React, {Component} from 'react';
import {Row, Col, FormControl, ButtonToolbar} from "react-bootstrap";
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';
import DefinicjeTrasSortableItem from "./DefinicjeTrasSortableItem";
import {TopButtonAdd, TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import Validator from "../../../../../utilities/Validator";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";


const SortableItem = SortableElement(({item, przystanki, handleChangeWartosc, disabledLabel, handleUsun}) =>
    <DefinicjeTrasSortableItem item={item} przystanki={przystanki} handleChangeWartosc={handleChangeWartosc} disabledLabel={disabledLabel}
                               handleUsun={handleUsun}/>
);

const SortableList = SortableContainer(({items, przystanki, handleChangeWartosc, disabled, handleUsun}) => {
    return (
        <div>
            {items.map((item, index) => (
                <SortableItem key={`item-${index}`} index={index} item={item} przystanki={przystanki} handleChangeWartosc={handleChangeWartosc}
                              disabled={disabled} disabledLabel={disabled} handleUsun={handleUsun}
                />
            ))}
        </div>
    );
});

export default class DefinicjeTrasLista extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            trybDodawanie: false,
            nowy_czas: '',
            nowy_km: '',
            nowy_przystanek: null,
            validatorMessages: [],

        };
        this.dodajDefinicjeTrasy = this.dodajDefinicjeTrasy.bind(this)
        this.anulujDodawanie = this.anulujDodawanie.bind(this)
        this.onChangeCzas = this.onChangeCzas.bind(this)
        this.onChangeKm = this.onChangeKm.bind(this)
        this.onChangePrzystanek = this.onChangePrzystanek.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    onSortEnd = ({oldIndex, newIndex}) => {

        let definicje_po_zmianie = arrayMove(this.props.definicje, oldIndex, newIndex)

        for (let i = 0; i < definicje_po_zmianie.length; i++) {
            definicje_po_zmianie[i].kol = i + 1
        }

        this.props.handleChangeKolejnosc(definicje_po_zmianie);

    };

    handleChangeWartosc(obj) {
        this.props.handleChangeWartosc(obj)
    }

    handleUsun(obj) {
        this.props.handleUsun(obj)
    }

    dodajDefinicjeTrasy() {
        this.setState({trybDodawanie: true})
    }

    anulujDodawanie() {
        this.setState({trybDodawanie: false})
    }

    onChangeCzas(e) {
        this.setState({nowy_czas: e.target.value})
    }

    onChangeKm(e) {
        this.setState({nowy_km: e.target.value})
    }

    onChangePrzystanek(e) {
        this.setState({nowy_przystanek: e})
    }

    renderPrzystanek(option) {
        return (
            <div>
                <span className={'label label-ebus-default'}>{option.nazMi}</span>
                <span style={{marginLeft: '7px'}}>{option.nazPr}</span>
            </div>
        )
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {

        this.state.validatorMessages = []

        let poprawne = true;

        if (!Boolean(this.state.nowy_przystanek)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono przystanku')
        }
        if (!Validator.validateInt(this.state.nowy_czas, false)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Niepoprawny czas od poprzedniego przystanku')
        }
        if (!Validator.validateIntOrDouble(this.state.nowy_km, false)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Niepoprawna ilość km od poprzedniego przystanku')
        }

        if (poprawne) {
            this.setState({validatorMessages: []})

            let data = {
                "idTr": this.props.obecnaTrasa,
                "idPr": this.state.nowy_przystanek.idPr,
                "kol": this.props.definicje.length + 1,
                "kmOdPoprz": this.state.nowy_km,
                "czasOdPoprz": this.state.nowy_czas,
            }

            this.props.handleDodaj(data);
            this.setState({
                trybDodawanie: false,
                nowy_czas: '',
                nowy_km: '',
                nowy_przystanek: null,
            })
        }
    }

    render() {

        return (
            <div id={'DefinicjeTrasLista'}>
                <TopIf isTrue={this.props.definicje.length > 0}>
                    <Row id={'defHeader'}>
                        <Col xs={12} lg={1}>
                            <i className={'fa fa-bars'}></i> Kolejność
                        </Col>
                        <Col xs={12} lg={1}>
                            Czas od początku
                        </Col>
                        <Col xs={12} lg={5}>
                            <Row>
                                <Col xs={12} lg={8}>
                                    Przystanek
                                </Col>
                                <Col xs={12} lg={4}>
                                    Koordynaty GPS
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Row>
                                <Col xs={12} lg={6}>
                                    Czas od poprzedniego
                                </Col>
                                <Col xs={12} lg={6}>
                                    Km od poprzedniego
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} lg={1}>

                            <div className={'pull-right'}>
                                <span className={'text-danger'}>Usuń przystanek</span>
                            </div>
                        </Col>
                    </Row>
                </TopIf>

                <SortableList items={this.props.definicje} onSortEnd={this.onSortEnd} przystanki={this.props.przystanki} useDragHandle={true}
                              handleChangeWartosc={this.handleChangeWartosc.bind(this)} disabled={this.state.disabled} lockAxis={'y'}
                              helperClass={'podswietlenieDnD'} handleUsun={this.handleUsun.bind(this)}/>

                <TopIf isTrue={this.props.czyPokazywacDodajButton}>
                    <div>
                        {
                            (!this.state.trybDodawanie) ?
                                <div style={{marginTop: '9px'}}>
                                    <Row>
                                        <Col xs={12}>
                                            <div className={'pull-right'}>
                                                <TopButtonAdd onClick={this.dodajDefinicjeTrasy} text={'Dodaj przystanek do trasy'}
                                                              buttonSize={'small'}/>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                :
                                <div className={'defItemDodawanie'}>
                                    <Row>
                                        <Col xs={12} lg={1}>
                                            <i className={'fa fa-bars'} style={{color: '#fff'}}></i>
                                            <span style={{marginLeft: '10px'}}>{this.props.definicje.length + 1}</span>
                                        </Col>
                                        <Col xs={12} lg={6} lgOffset={2}>
                                            <Row>
                                                <Col xs={12} lg={5}>
                                                    <TopSelect onChange={this.onChangePrzystanek}
                                                               value={this.state.nowy_przystanek}
                                                               options={this.props.przystanki}
                                                               labelKey={'nazMi'}
                                                               valueKey={'idPr'}
                                                               optionRenderer={this.renderPrzystanek}
                                                               valueRenderer={this.renderPrzystanek}
                                                               placeholder={'Wybierz przystanek'}
                                                    />
                                                </Col>
                                                <Col xs={12} lg={2} lgOffset={1}>
                                                    <FormControl placeholder={'czas od poprzedniego'} onChange={this.onChangeCzas}/>
                                                </Col>
                                                <Col xs={12} lg={2} lgOffset={1}>
                                                    <FormControl placeholder={'km od poprzedniego'} onChange={this.onChangeKm}/>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <div className={'pull-right'}>
                                                <ButtonToolbar>
                                                    <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz przystanek'} buttonSize={'small'}/>
                                                    <TopButtonCancel onClick={this.anulujDodawanie} buttonSize={'small'} text={'Anuluj dodawanie'}/>
                                                </ButtonToolbar>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} lg={9} lgOffset={3}>
                                            <Row>
                                                <ValidatorMessages messages={this.state.validatorMessages}/>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                        }
                        <div style={{height: '15px'}}></div>
                    </div>
                </TopIf>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/definicjeTras/components/DefinicjeTrasLista.js